import {createAction, props} from '@ngrx/store';
import {HttpErrorResponse} from '@angular/common/http';
import {DahLoadingType} from '@common/components-module/core-components.models';
import {DahPaginationModel} from '@common/models/commonHTTP.models';
import {DashboardRequests, DashboardRow, DashboardSearchParams} from '@communication/_common/models/dashboard.models';

export const CheckState = createAction(
    '[Dashboard] Check State',
    props<{ payload: { modalView: boolean, close: boolean, items: DashboardRow[] } }>()
);

export const LoadList = createAction(
    '[Dashboard] Load List',
    props<{ payload: { loading: DahLoadingType, clearState: boolean } }>()
);

export const LoadRequestsSuccess = createAction(
    '[Dashboard] Load Requests Success',
    props<{ requests: DashboardRequests[] }>()
);

export const LoadListSuccess = createAction(
    '[Dashboard] Load List Success',
    props<{ payload: { items: DashboardRow[], pagination: DahPaginationModel, clearState: boolean, activeVotingExists: boolean } }>()
);

export const LoadListFailure = createAction(
    '[Dashboard] Load List Failure',
    props<{ payload: HttpErrorResponse }>()
);

export const SetPagination = createAction(
    '[Dashboard] Set Pagination',
    props<{ payload: boolean }>()
);

export const SetFilter = createAction(
    '[Dashboard] Set Filter',
    props<{ payload: DashboardSearchParams }>()
);

export const SetLoading = createAction(
    '[Dashboard] Set Loading',
    props<{ payload: DahLoadingType }>()
);

export const SetItemsLoading = createAction(
    '[Dashboard] Set Items Loading',
    props<{ payload: { id: string, isStart: boolean } }>()
);

export const UpdateItemSuccess = createAction(
    '[Dashboard] Update Item Success',
    props<{ payload: DashboardRow }>()
);

export const SetInitialState = createAction(
    '[Dashboard] Set Initial State'
);
